import { UserValidationActions } from '@/app/platform/platform-core/user/store/types';
import { AsyncResult } from '@common/result/asyncResult';
import { PlatformUser } from '@/app/platform/platform-core/user/models/platform-user';
import { ErrorInformation } from '@shared/models/error/error-information';
import { InvalidResult, ok, ValidResult } from '@common/result/Result';
import { AUTHENTICATION_SERVICE, AuthenticationService } from '@/app/platform/platform-core/user/services/types';
import { Inject, Injectable } from '@angular/core';
import { USER_ACTIVATOR, UserActivator } from '@/app/platform/platform-core/user/activators/types';
import { Credentials } from '@/app/platform/platform-shared/models/credentials';

@Injectable({
  providedIn: 'root'
})
export class UserValidationStoreActions implements UserValidationActions {
  constructor(
    @Inject(AUTHENTICATION_SERVICE)
    private readonly authService: AuthenticationService,
    @Inject(USER_ACTIVATOR)
    private readonly userActivator: UserActivator
  ) {}

  async validateCredentials(credentials: Credentials): AsyncResult<PlatformUser> {
    const validationResult = await this.authService.validateCredentials(credentials);

    if (validationResult instanceof InvalidResult) {
      return validationResult;
    }

    return await this.authenticateUserOnDesktop(validationResult);
  }

  private async authenticateUserOnDesktop(
    validationResult: ValidResult<
      [user: PlatformUser, authenticationOnlyToken: string],
      ErrorInformation<string>
    >
  ): AsyncResult<PlatformUser> {
    const token = validationResult.value[1];
    const authenticationResult = await this.authService.authenticate(token);

    if (authenticationResult instanceof InvalidResult) {
      return authenticationResult;
    }

    const authenticationResponse = authenticationResult.value;

    this.userActivator.activateOnDesktop(authenticationResponse, true);
    return ok(authenticationResponse.authentication.user);
  }
}
